export const ALERT = {
  ALERT_LIST_DETAIL_HISTORY_LIST_DASHBOARD_SETTING_LIST:
    'ALERT_LIST_DETAIL_HISTORY_LIST_DASHBOARD_SETTING_LIST',
  GRIDCOLUMNS_alert_alertList_alertList: 'GRIDCOLUMNS_alert_alertList_alertList',
  GRIDCOLUMNS_alert_alertDetail_current: 'GRIDCOLUMNS_alert_alertDetail_current',
  GRIDCOLUMNS_alert_alertDetail_historyList: 'GRIDCOLUMNS_alert_alertDetail_historyList',
  GRIDCOLUMNS_alert_alertDetail_systemAlert: 'GRIDCOLUMNS_alert_alertDetail_systemAlert',
  GRIDCOLUMNS_alert_alertDetail_primaryCausesList:
    'GRIDCOLUMNS_alert_alertDetail_primaryCausesList',
  GRIDCOLUMNS_alert_eventAlertList: 'GRIDCOLUMNS_alert_eventAlertList',
  GRIDCOLUMNS_alert_eventAlertList_targetViewList:
    'GRIDCOLUMNS_alert_eventAlertList_targetViewList',
  GRIDCOLUMNS_alert_eventAlertDetail_systemAlert: 'GRIDCOLUMNS_alert_eventAlertDetail_systemAlert',
  GRIDCOLUMNS_alert_notificationHistory_notificationHistoryList:
    'GRIDCOLUMNS_alert_notificationHistory_notificationHistoryList',
  GRIDCOLUMNS_alert_platformDetail_alertLogs: 'GRIDCOLUMNS_alert_platformDetail_alertLogs',

  FILTER_alert_alertList: 'FILTER_alert_alertList',
  FILTER_alert_eventAlertList: 'FILTER_alert_eventAlertList',
  FILTER_alert_notificationHistory: 'FILTER_alert_notificationHistory',

  FILTERSEARCH_alert_alertList_alertList: 'FILTERSEARCH_alert_alertList_alertList',
  FILTERSEARCH_alert_eventAlertList_eventAlertList:
    'FILTERSEARCH_alert_eventAlertList_eventAlertList',
  FILTERSEARCH_alert_notificationHistory_notificationHistoryList:
    'FILTERSEARCH_alert_notificationHistory_notificationHistoryList',
  FILTERSEARCH_alert_platformDetail_ruleList: 'FILTERSEARCH_alert_platformDetail_ruleList',
  FILTERSEARCH_alert_alertDetail_current: 'FILTERSEARCH_alert_alertDetail_current',
  FILTERSEARCH_alert_alertDetail_historyList: 'FILTERSEARCH_alert_alertDetail_historyList',
  FILTERSEARCH_alert_alertDetail_systemAlert: 'FILTERSEARCH_alert_alertDetail_systemAlert',
  FILTERSEARCH_alert_eventAlertDetail_systemAlert:
    'FILTERSEARCH_alert_eventAlertDetail_systemAlert',
  FILTERSEARCH_alert_eventAlertDetail_hostProcessList:
    'FILTERSEARCH_alert_eventAlertDetail_hostProcessList',
  FILTERSEARCH_alert_eventAlertDetail_matchedProcessList:
    'FILTERSEARCH_alert_eventAlertDetail_matchedProcessList',
  FILTERSEARCH_external_alert_ruleList: 'FILTERSEARCH_external_alert_ruleList',

  TARGET_TAGS_alert_eventAlertList: 'TARGET_TAGS_alert_eventAlertList',
  TARGET_TYPES_alert_eventAlertList: 'TARGET_TYPES_alert_eventAlertList',
  RULE_TYPE_alert_eventAlertList: 'RULE_TYPE_alert_eventAlertList',

  TOGGLE_alert_alertDetail_ruleData_expanded: 'TOGGLE_alert_alertDetail_ruleData_expanded',
  TOGGLE_alert_alertDetail_matchedProcess_expanded:
    'TOGGLE_alert_alertDetail_matchedProcess_expanded',

  TOGGLE_alert_eventAlertDetail_ruleData_expanded:
    'TOGGLE_alert_eventAlertDetail_ruleData_expanded',
  TOGGLE_alert_eventAlertDetail_occurrenceMessage_expanded:
    'TOGGLE_alert_eventAlertDetail_occurrenceMessage_expanded',
  TOGGLE_alert_eventAlertDetail_processList_expanded:
    'TOGGLE_alert_eventAlertDetail_processList_expanded',
  TAB_alert_alertDetail_selected: 'TAB_alert_alertDetail_selected',
  TAB_alert_eventAlertDetail_selected: 'TAB_alert_eventAlertDetail_selected',
};
